
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/franchise/international",
      function () {
        return require("private-next-pages/franchise/international.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/franchise/international"])
      });
    }
  